function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "camera-plus_svg__a",
  d: "M21 18v-2h2v2h2v2h-2v2h-2v-2h-2v-2h2zm-3.584 3H2a2 2 0 01-2-2V5a2 2 0 012-2h3.5L7 0h10l1.5 3H22a2 2 0 012 2v9.416A5 5 0 0017.416 21zM12 18a6 6 0 100-12 6 6 0 000 12zm0-2a4 4 0 110-8 4 4 0 010 8z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "translate(4 6)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "camera-plus_svg__b",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#camera-plus_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#camera-plus_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#camera-plus_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4-6h32v32H-4z"
})));

function SvgCameraPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgCameraPlus;